import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import { useEffect } from "react";

export default function Layout() {
    const { pathname } = useLocation();

    // Re-run scroll-reveal observer on every route change so elements on
    // newly mounted pages get picked up (and any element already in the
    // viewport at mount becomes visible immediately).
    useEffect(() => {
        // Defer to next frame so React has finished painting the new route.
        const raf = requestAnimationFrame(() => {
            const els = document.querySelectorAll(".fade-up:not(.is-visible)");

            // Anything currently in the viewport reveals immediately.
            const reveal = (el) => el.classList.add("is-visible");
            const vh = window.innerHeight;
            els.forEach((el) => {
                const rect = el.getBoundingClientRect();
                if (rect.top < vh * 0.92) reveal(el);
            });

            const io = new IntersectionObserver(
                (entries) => {
                    entries.forEach((e) => {
                        if (e.isIntersecting) {
                            reveal(e.target);
                            io.unobserve(e.target);
                        }
                    });
                },
                { threshold: 0.08, rootMargin: "0px 0px -8% 0px" }
            );
            document
                .querySelectorAll(".fade-up:not(.is-visible)")
                .forEach((el) => io.observe(el));

            // Save observer on element for cleanup
            return () => io.disconnect();
        });

        return () => cancelAnimationFrame(raf);
    }, [pathname]);

    return (
        <div className="min-h-screen flex flex-col bg-bb-cream relative">
            {/* Fixed leopard print strip on the left side – visible as user scrolls */}
            <div
                aria-hidden="true"
                className="hidden md:block fixed left-0 top-0 bottom-0 z-[30] w-8 lg:w-12 xl:w-14 pointer-events-none"
                style={{
                    backgroundImage:
                        "url('https://customer-assets.emergentagent.com/job_faith-fashion-gift/artifacts/fe8mb5ib_icm_fullxfull.896388187_iuqo32qc4m0csscokkg0.jpg')",
                    backgroundRepeat: "repeat",
                    backgroundSize: "auto 220px",
                    backgroundPosition: "left top",
                    opacity: 0.95,
                }}
                data-testid="leopard-strip"
            />
            <Navbar />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            <CartDrawer />
        </div>
    );
}
